import cn from 'classnames'
import React, { FC, InputHTMLAttributes, useRef, ChangeEvent } from 'react'
import { safeParseEventValue } from 'common/utils/forms/safeEventParseValue'

type CheckboxProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string
  id: string
  checked: boolean
  onChange?: (newValue: boolean) => void
}

const Checkbox: FC<CheckboxProps> = ({
  checked,
  className,
  id,
  label,
  onChange,
  ...rest
}) => {
  const checkboxRef = useRef<HTMLInputElement>(null)
  return (
    <div
      onClick={() => {
        if (!rest.disabled) {
          onChange?.(!checked)
        }
      }}
      className={cn(
        'lh-input d-flex align-items-center cursor-pointer user-select-none',
        className,
      )}
    >
      {checked ? (
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z'
            fill='#1977EC'
          />
          <path
            d='M10.243 16.485L6 12.242L7.414 10.828L10.243 13.657L15.899 8L17.314 9.414L10.243 16.485Z'
            fill='white'
          />
        </svg>
      ) : (
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='12' cy='12' r='9.5' stroke='#1D1D1F' />
        </svg>
      )}
      {label && (
        <label className='form-check-label' htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  )
}

Checkbox.displayName = 'Checkbox'
export default Checkbox
